import * as React from 'react';

import BillingAddress from 'src/components/BillingAddress';

import './BillingAddressView.scss';

class BillingAddressView extends React.Component {
  public render() {
    return (
      <div className="rp-billing-address-view">
        <BillingAddress />
      </div>
    );
  }
}

export default BillingAddressView;
